// extracted by mini-css-extract-plugin
export default {"contentWrapper":"auth-layout_contentWrapper__UKxcq"};